import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";

import { ReviewFlightItinerary } from "./component";
import {
  getAirportMap,
  getIsTripVoidWindowEligible,
  getPackagesByReturnFareSlice,
  getParsedPackagesByOutboundFareSlice,
  getSelectedTrip,
  getUserSelectedRecommendedFlight,
  isOutgoingMultiTicketSelector,
  isReturnMultiTicketSelector,
  selectedFareDetailsSelector,
} from "../../../flight-shop/reducer";
import { finalizePackage } from "./../../actions/actions";
import {
  getHotelShopChosenProduct,
  getPackageSelectedLodging,
  getSelectedPackageByLodgingId,
} from "../../../hotel-shop/reducer";
import { getDepartureDate, getReturnDate } from "../../../search/reducer";
import { getTravelersCount } from "../../../availability/reducer";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => {
  const selectedTrip = getSelectedTrip(state);
  const outboundPackageSlices = getParsedPackagesByOutboundFareSlice(state);

  return {
    selectedTrip,
    getPackagesByReturnFareSlice: getPackagesByReturnFareSlice(state),
    selectedLodging: getPackageSelectedLodging(state),
    departureDate: getDepartureDate(state),
    returnDate: getReturnDate(state),
    chosenProduct: getHotelShopChosenProduct(state),
    selectedPackageByLodging: getSelectedPackageByLodgingId(state),
    rewardsKey:
      getSelectedAccountReferenceIdIfRedemptionEnabled(state) || undefined,
    travelersCount: getTravelersCount(state),
    selectedPackageByFlight: selectedTrip?.outgoingFareSliceId
      ? outboundPackageSlices[selectedTrip.outgoingFareSliceId]
      : undefined,
    airports: getAirportMap(state),
    fareDetails: selectedFareDetailsSelector(state),
    isMultiTicket:
      isOutgoingMultiTicketSelector(state) ||
      isReturnMultiTicketSelector(state),
    isVoidWindowEligible: getIsTripVoidWindowEligible(state),
    userSelectedRecommendedFlight: getUserSelectedRecommendedFlight(state),
  };
};

export const mapDispatchToProps = {
  finalizePackage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type ReviewFlightItineraryConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedReviewFlightItinerary = withRouter(
  connector(ReviewFlightItinerary)
);